import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React, {useContext, useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom';
import UsuarioView from "../../../components/usuario/usuarioView";
import {getById} from '../../../services/usuario/UsuarioService';
import useStyles from './styles';
import {AppContext} from '../../../components/shared/context';
import TipoPerfil from "../../../constants/tipoPerfil";

const VisualizarUsuario = (props) => {
  const classes = useStyles();
  const { history } = props;
  const { keycloak , role } = useContext(AppContext);
  const id = props.match.params.id;
  const [form, setForm] = useState({});
  const [mostrarEditarPerfil, setMostarEditarPerfil] = useState(false);

  useEffect(() => {
    getById(id).then((response) => {
      if (response && response.status === 200) {
        const { data } = response;
        console.log(data)
        setForm(data)
        setMostarEditarPerfil(TipoPerfil.EQUIPE_TECNICA.is(role) || keycloak.tokenParsed.sub === data.sub);
      }
    })
  }, [])

  const editarPerfil = () => {
    history.push(`/usuario/${id}/editar`)
  }

  return (
    <div className={classes.jumbotron}>
      <div className={classes.barraAzul}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 50px 0px 49px' }}>
          <Button
            style={{ color: '#fff' }}
            startIcon={<ArrowBackIosIcon />}
            onClick={() => history.goBack()}>
            Voltar
          </Button>
          {mostrarEditarPerfil && <Button
            color="inherit"
            variant="contained"
            onClick={editarPerfil}>
            Editar perfil
          </Button>}
        </div>
      </div>
      <Container maxWidth="sm">
        <UsuarioView form={form} />
      </Container>
    </div>
  )
}

export default withRouter(VisualizarUsuario);
